// istanbul ignore file
import { createTheme, globalTheme } from '@clds/component-theme';

export const t = createTheme({
  width: '480px',
  padding: {
    vertical: globalTheme.spacing.xxl,
  },
  border: {
    radius: globalTheme.radius.xl,
  },
  // TODO: do sth with that copied color from TransformationsPageTheme
  background: '#8600e4',
  child: {
    margin: globalTheme.spacing.md,
  },
  image: {
    height: '230px',
    width: '230px',
    url: 'https://cloudinary-res.cloudinary.com/image/upload/f_auto,q_auto/v1592468593/dev-console-ui/transformations-manager-empty-state.png',
  },
});
